import { useQuery } from "@tanstack/react-query";
import { ClientHandlingErrorStatusCode, EHttpStatusCodeSuccess } from "@devowl-wp/api";
import { useStores } from "../store/root.js";
import { getClient } from "../util/api-fetch.js";
import { QueryKeys } from "../util/query-keys.js";
function useUntranslatables(templateType, templateIdentifier, isEnabled = true) {
    const { rcbAuthenticationStore } = useStores();
    const untranslatablesQuery = useQuery(QueryKeys.getUntranslatables(templateType, templateIdentifier), async ({ signal })=>{
        const params = {};
        if (templateType) {
            params.templateType = templateType;
        }
        if (templateIdentifier) {
            params.templateIdentifier = templateIdentifier;
        }
        const result = await getClient().template.untranslatable.get({
            params,
            signal,
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            }
        });
        switch(result.status){
            case EHttpStatusCodeSuccess.OK:
                return result.response;
            case ClientHandlingErrorStatusCode:
                throw result.error;
            default:
                throw result.response;
        }
    }, {
        enabled: isEnabled && !!rcbAuthenticationStore?.session?.jwt,
        keepPreviousData: true
    });
    return untranslatablesQuery;
}
export { useUntranslatables };
